import { trpc } from '@/lib/api/trpc';

export function useUnpaidInvoices(enabled: boolean = true) {
    const { data, isLoading } = trpc.stripe.getUnpaidInvoices.useQuery(
        {},
        {
            enabled,
            staleTime: 5 * 60 * 1000,
            gcTime: 10 * 60 * 1000,
            refetchOnWindowFocus: false,
            retry: 1,
        }
    );

    const invoices = data ?? [];
    const totalAmount = invoices.reduce((sum, inv) => sum + inv.amount, 0);
    const currency = invoices[0]?.currency ?? 'usd';

    return {
        invoices,
        invoiceCount: invoices.length,
        totalAmount,
        currency,
        isLoading,
    };
}
